<template>
  <PageLayout :title="$t('admin.app_review_title')" :subtitle="$t('admin.app_review_subtitle')">
    <ContentCard>
      <p class="text-muted small mb-3">{{ $t('admin.app_review_hint') }}</p>
      <div v-if="loading" class="text-muted">{{ $t('common.loading') }}</div>
      <template v-else>
        <textarea
          ref="instructionsBox"
          v-model="instructions"
          class="form-control app-review-instructions"
          rows="18"
          readonly
        ></textarea>
        <div class="d-flex flex-wrap gap-2 mt-3">
          <button type="button" class="btn btn-primary btn-sm" @click="copyInstructions">
            <i class="fas fa-copy mr-1"></i>
            {{ $t('admin.app_review_copy') }}
          </button>
          <router-link to="/admin/integrations" class="btn btn-outline-secondary btn-sm">
            {{ $t('admin.app_review_configure') }}
          </router-link>
        </div>
      </template>
    </ContentCard>
  </PageLayout>
</template>

<script>
import i18nPage from '@/mixins/i18nPage'
import { getAppReviewCommentInstructions } from '@/api/admin'

export default {
  mixins: [i18nPage],
  data() {
    return {
      loading: true,
      instructions: '',
    }
  },
  async created() {
    await this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const { data } = await getAppReviewCommentInstructions()
        const payload = data.data || data
        this.instructions = payload.instructions || ''
      } catch (e) {
        this.$toast.error(this.$t('admin.app_review_load_failed'))
      } finally {
        this.loading = false
      }
    },
    async copyInstructions() {
      if (!this.instructions) return
      try {
        await navigator.clipboard.writeText(this.instructions)
        this.$toast.success(this.$t('admin.app_review_copied'))
      } catch (e) {
        this.$toast.error(this.$t('common.copy_failed'))
      }
    },
  },
}
</script>

<style scoped>
.app-review-instructions {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
  line-height: 1.5;
  white-space: pre-wrap;
}
</style>
